import { useSelector } from 'react-redux'
import { format } from 'date-fns'
import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import TimeIcon from '@mui/icons-material/AccessTime'
import { formatDate } from '../../util/dateTimeFormat'
import { RootStateType } from '../../redux/reducer/rootReducer'

type CoreTitleProps = {
    label: string
    date?: string
    displayDate?: boolean
}

const CoreTitle = (props: CoreTitleProps) => {
    const language = useSelector((state: RootStateType) => state.language).toUpperCase() as 'TH' | 'EN'
    const classes = useStyles()
    const { label, date, displayDate = true } = props

    return (
        <StyledContainer>
            <StyledContainerTitle>
                <StyledTypoTitle variant="h5" style={{ fontWeight: 'bold' }}>
                    {label}
                </StyledTypoTitle>
                {displayDate && (
                    <StyledSubTitle>
                        <TimeIcon />
                        <StyledTypoSubTitle variant="subtitle1">{`อัพเดทข้อมูลวันที่ ${formatDate({
                            date: date ? format(new Date(date), 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd'),
                            lang: language,
                        })}`}</StyledTypoSubTitle>
                    </StyledSubTitle>
                )}
            </StyledContainerTitle>
            <StyledDivDivider>
                <div>
                    <Divider className={classes.shortDivider} />
                </div>
                <div style={{ width: '100%' }}>
                    <Divider className={classes.longDivider} />
                </div>
            </StyledDivDivider>
        </StyledContainer>
    )
}

export default CoreTitle

const useStyles = makeStyles((theme: Theme) => ({
    shortDivider: {
        width: '50px !important',
        border: `2px solid ${theme.palette.primary.main} !important`,
    },
    longDivider: {
        width: '100% !important',
    },
}))

const StyledContainer = styled('div')(({ theme }) => ({
    padding: '5px 0px',
}))

const StyledContainerTitle = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(2),
}))

const StyledSubTitle = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(1),
    color: theme.palette.text.disabled,
    display: 'flex',
}))

const StyledTypoTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.secondary.dark,
}))

const StyledTypoSubTitle = styled(Typography)(({ theme }) => ({
    paddingLeft: '5px !important',
}))

const StyledDivDivider = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'left',
    },
}))
